var React = require('react');

function CheckIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"primary-fill","d":"M30.264,41.478,25.591,36.8a1.028,1.028,0,0,0-1.454,1.454l6.127,6.127L42,32.65A1.028,1.028,0,0,0,40.547,31.2Z","transform":"translate(-23.826 -30.885)"}));
}

CheckIcon.defaultProps = {"viewBox":"0 0 18.486 13.502","className":"icon check-skinny"};

module.exports = CheckIcon;

CheckIcon.default = CheckIcon;
